export const colors = {
    // Primary colors - Purple/Blue theme
    primary: {
        25: '#f5f3ff',
        50: '#ede9fe',
        100: '#ddd6fe',
        200: '#c4b5fd',
        300: '#a78bfa',
        400: '#8b5cf6',
        500: '#7c3aed', // Main primary - Purple
        600: '#6d28d9',
        700: '#5b21b6',
        800: '#4c1d95',
        900: '#3b1a7a',
    },

    // Secondary colors - Professional grays
    secondary: {
        50: '#f8f9fa',
        100: '#e9ecef',
        200: '#dee2e6',
        300: '#ced4da',
        400: '#adb5bd',
        500: '#6c757d',
        600: '#495057',
        700: '#343a40',
        800: '#212529',
        900: '#0d1117',
    },

    // Accent colors - Security theme
    accent: {
        success: '#28a745',
        warning: '#ffc107',
        danger: '#dc3545',
        info: '#17a2b8',
    },

    // Neutral colors
    white: '#ffffff',
    black: '#000000',

    // Light theme colors
    light: {
        background: {
            primary: '#ffffff',
            secondary: '#f8f9fa',
            tertiary: '#e9ecef',
        },
        text: {
            primary: '#212529',
            secondary: '#6c757d',
            muted: '#adb5bd',
            inverse: '#ffffff',
        },
        border: {
            light: '#dee2e6',
            medium: '#ced4da',
            dark: '#adb5bd',
        }
    },

    // Dark theme colors
    dark: {
        background: {
            primary: '#0d1117',
            secondary: '#161b22',
            tertiary: '#21262d',
        },
        text: {
            primary: '#f0f6fc',
            secondary: '#8b949e',
            muted: '#6e7681',
            inverse: '#0d1117',
        },
        border: {
            light: '#30363d',
            medium: '#21262d',
            dark: '#161b22',
        }
    }
};
